import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';
import RedesignDescriptor from './common-components-redesign';
import RefiveDescriptor from './common-components-refive';
import Settings from 'src/Settings';

const typeDescriber = {
  [BuildTypeEnum.canteen]: RedesignDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
